import React, { Component } from 'react'
import { links } from '../../../quality/constants/StationsConstants'
import i18n from 'simple-react-i18n'
import {
    H_HYDRO_CAMPAIGN,
    H_HYDRO_DASHBOARD,
    H_HYDRO_EXPORT,
    H_HYDRO_GRAPHIC,
    H_HYDRO_MAP_SITUATION,
    H_HYDRO_OPTIONS,
    H_HYDRO_SITUATION, H_STATION_HYDRO_IMPORT,
    H_STATION_HYDRO_MODELS,
} from '../../../account/constants/AccessRulesConstants'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import FixedSlideNav from '../../../components/navbar/FixedSlideNav'
import BoundaryError from '../../../log/components/BoundaryError'
import { Outlet } from 'react-router-dom'
import PropTypes from 'prop-types'
import User from '../../../account/dto/User'
import { connect } from 'react-redux'
import GlobalParametersDto from 'administration/dto/GlobalParameterDto'
import UserDto from 'administration/components/user/dto/UserDto'
import AdministrationAction from 'administration/actions/AdministrationAction'
import { Box } from '@mui/material'
import { IMPORT_TYPE } from 'traitements/constants/TraitementConstants'

const IMPORT_HYDRO = 'importHydro'

class HydrometersApp extends Component {
    componentDidMount() {
        const { globalParameters } = this.props
        if (!globalParameters.length) {
            this.props.fetchGlobalParameters()
        }
    }

    getLink = (linkName) => {
        const link = links[linkName]

        return {
            ...link,
            href: link.href || `/hydrometry/${link.hrefName || linkName}`,
            name: i18n[link.i18n],
            state: linkName === IMPORT_HYDRO ? { hasToOpen: true, initialType: IMPORT_TYPE.HYDRO_PORTAIL } : undefined,
        }
    }

    getLinksHabilitations = () => {
        return [
            ...[
                { linkName: 'dashboard', habilitation: H_HYDRO_DASHBOARD },
                { linkName: 'importHydro', habilitation: H_STATION_HYDRO_IMPORT },
                // exportOverview
                { linkName: 'export', habilitation: H_HYDRO_EXPORT },
                { linkName: 'integrationOverview', habilitation: H_HYDRO_SITUATION },
                { linkName: 'campaign', habilitation: H_HYDRO_CAMPAIGN },
                { linkName: 'graphic', habilitation: H_HYDRO_GRAPHIC },
                // diagnostics
                { linkName: 'hydrometryOptions', habilitation: H_HYDRO_OPTIONS },
                { linkName: 'mapSituations', habilitation: H_HYDRO_MAP_SITUATION },
                { linkName: 'iaeauModels', habilitation: H_STATION_HYDRO_MODELS },
            ].filter(l => componentHasHabilitations(l.habilitation)),
        ]
    }

    render() {
        const baseLinks = this.getLinksHabilitations().filter(l => l)
        const navBarLinks = baseLinks.map(a => this.getLink(a.linkName))
        return (
            <div>
                <FixedSlideNav links={navBarLinks}/>
                <main>
                    <div className='content-page fullscreen'>
                        <BoundaryError>
                            <Box sx={{ padding: '10px' }}>
                                <Outlet />
                            </Box>
                        </BoundaryError>
                    </div>
                </main>
            </div>
        )
    }
}

HydrometersApp.propTypes = {
    children: PropTypes.element,
    getLink: PropTypes.func,
    accountUser: PropTypes.instanceOf(User),
    globalParameters: PropTypes.arrayOf(PropTypes.instanceOf(GlobalParametersDto)),
    users: PropTypes.arrayOf(PropTypes.instanceOf(UserDto)),
    fetchGlobalParameters: PropTypes.func,
}

const mapStateToProps = store => ({
    accountUser: store.AccountReducer.accountUser,
    globalParameters: store.AdministrationReducer.globalParameters,
    users: store.UserReducer.users,
})

const mapDispatchToProps = {
    fetchGlobalParameters: AdministrationAction.fetchGlobalParameters,
}

export default connect(mapStateToProps, mapDispatchToProps)(HydrometersApp)
